import type { TRouteObject } from "@ch/helpers/utils/types";
import ChatPageLazy from "@ch/pages/ChatPage";
import ErrorPage from "@ch/pages/ErrorPage";

const ChatRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <ChatPageLazy />,
      },
    ],
  },
];

export default ChatRoutes;
